import { loadStripe } from '@stripe/stripe-js/pure';

const API_KEY_STRIPE = import.meta.env.VITE_API_KEY_STRIPE;

/**
 * Centralized Stripe configuration
 *
 * advancedFraudSignals must be disabled BEFORE the first loadStripe() call
 * via setLoadParameters (the `/pure` entry point exposes this). Passing the
 * flag as the second argument of loadStripe() is silently ignored — that
 * slot is StripeConstructorOptions, not LoadParameters.
 *
 * Disabling kills the bulk of background calls to https://r.stripe.com/b
 * and https://m.stripe.com/* (behavioral / fraud telemetry) that fire on
 * every Elements mount and on every keystroke inside Card* iframes.
 */
loadStripe.setLoadParameters({ advancedFraudSignals: false });

export const stripePromise = loadStripe(API_KEY_STRIPE);
